import React, { Fragment } from 'react'

import SafeSearchTerms from '@/docs-partials/trust-and-safety/safe-search-terms.mdx'
import GIFBlockingTool from '@/docs-partials/trust-and-safety/gif-blocking-tool.mdx'
import { DocsSection } from '@/components/common/docs-section'

const OptionalSettings = () => {
  return (
    <Fragment>
      <div className="docsContainer">
        <DocsSection dividerLine={false} anchorId="safe-search-terms">
          <SafeSearchTerms />
        </DocsSection>
        <DocsSection dividerLine={false} anchorId="gif-blocking-tool">
          <GIFBlockingTool />
        </DocsSection>
      </div>
    </Fragment>
  )
}

export default OptionalSettings
